import React from 'react';
import { CloseIcon, ZoomCameraFillIcon } from '@bizzabo/icons';
import BZModal from 'BZModal';
import webcastingType from 'web-common/scripts/enums/webcastingTypeEnum';

const buttonText = {
    live: 'Join Live Session',
    onDemand: 'Watch Session'
};

const explanationText = {
    live: 'Press continue to join the live session.',
    onDemand: 'Press continue to watch the session.'
};

const ExternalUrlRedirectModal = ({ show, onHide, onContinue, isLive = true, type }) => (
    <BZModal
        modalCls="agenda-modal redirect-to-another-page-modal"
        color='white'
        show={show}
        onHide={onHide}
        hideFooter
    >
        <button className="close-btn custom-color color-1-background" onClick={onHide}>
            <CloseIcon fill='#fff' />
        </button>
        <div className="inner-container">
            {type === webcastingType.ZOOM ? (
                <>
                    <div className="text-center">
                        <h4 className="modal-title margin-bottom-small margin-top-small">
                            Join Breakout Rooms on Zoom
                        </h4>
                        <div className="modal-text">
                            This session will be on Zoom and will open in a new page
                        </div>
                    </div>
                    <button
                        type="button"
                        className="zoom-button text-uppercase bz-button font-size-13 custom-color color-1-background color-1-hover-opacity"
                        onClick={onContinue}
                    >
                        <ZoomCameraFillIcon className="zoom-camera-icon"/>
                        Join Breakout Rooms on Zoom
                    </button>
                </>
            ) : (
                <>
                    <div className="text-center">
                        <h4 className="modal-title margin-bottom-small">{isLive ? buttonText.live : buttonText.onDemand}</h4>
                        <div className="modal-text">You are about to be redirected to another page.</div>
                        <div>{isLive ? explanationText.live : explanationText.onDemand}</div>
                    </div>
                    <button
                        className="continue-btn custom-color color-1-background font-size-13"
                        onClick={onContinue}
                    >
                        Continue
                    </button>
                </>
            )}
        </div>
    </BZModal>
);

export default ExternalUrlRedirectModal;
